import * as React from "react";
import { Chip, ChipSize } from "../ui";
import {
  StatusPillOutline,
  StatusPillStyle,
  StatusTone,
  statusPillColors,
  statusPillOutline,
} from "../../lib/statusTone.utils";

export { StatusPillOutline, StatusPillStyle };

/** A status in its tone's colours. Flat by default so it never reads as a button. */
export const StatusPill: React.FC<{
  label: string;
  tone: StatusTone;
  ariaLabel: string;
  variant?: StatusPillStyle;
  outline?: StatusPillOutline;
  size?: ChipSize;
  className?: string;
  /** Size or spacing for a particular place, applied over the defaults. */
  style?: React.CSSProperties;
}> = ({
  label,
  tone,
  ariaLabel,
  variant = StatusPillStyle.FLAT,
  outline = StatusPillOutline.NONE,
  size,
  className,
  style,
}) => (
  <Chip
    label={label}
    aria-label={ariaLabel}
    size={size}
    className={className}
    style={{
      flexShrink: 0,
      height: 26,
      fontSize: 13,
      fontWeight: 600,
      ...statusPillColors(tone, variant),
      ...statusPillOutline(outline),
      ...style,
    }}
  />
);
